import {Bounce, toast} from "react-toastify";

export const listToTree = (list , selectedIds = []) => {
    var map = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
        list[i].children = []; // initialize the children

        if (selectedIds.includes(list[i].id)){
            list[i].checked = true;
        }else{
            list[i].checked = false;
        }
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parentId != null) {
            // if you have dangling branches check that map[node.parentId] exists
            list[map[node.parentId]].children.push(node);
        } else {
            roots.push(node);
        }
    }
    return roots;
}

export const base64DecodeUnicode = (base64) =>{
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
export const capitalizeFirstLetter = (string) => {
    return string[0].toUpperCase() + string.slice(1);
}

export const toastSuccess = (message) => {
    const toastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        rtl : true,
        transition: Bounce,
    };
    toast.success(message, toastOptions);
}

export const toastWarning = (message) => {
    const toastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        rtl : true,
        transition: Bounce,
    };
    toast.warn(message, toastOptions);
}
export const toastError = (message) => {
    const toastOptions = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        rtl : true,
        transition: Bounce,
    };
    toast.error(message, toastOptions);
}